// @flow
import { PdfPrintAction } from "hooks/PostMessage/Actions";
import { postMessageTo } from "hooks/PostMessage/Utils";
/**
 * trigger pdf.js print dialog
 */

type Context = DocModalProps & {
    target?: any,
};

class doc_print {
    execute = ({ target = window }: Context) => {
        postMessageTo(PdfPrintAction, null, target);
        return true;
    };
}
export default doc_print;
